import { render } from "./DespesasGruposTabPage.vue?vue&type=template&id=6f63aea8"
import script from "./DespesasGruposTabPage.vue?vue&type=script&lang=js"
export * from "./DespesasGruposTabPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__